import React from 'react';
import PropTypes from 'prop-types';
import { useFormState } from 'react-final-form';

import { MainView } from '../../../templates/MainView';
import { Heading } from '../../../components/atoms/Heading';
import { Text } from '../../../components/atoms/Text';
import { Field } from '../../../components/molecules/Field';

import phoneUK from '../../../components/validation/phoneUK';

import { useContactPreferenceOptions } from '../../../lib/useContactPreferenceOptions';

/**
 * Primary UI component for user interaction
 */
export const ReEngagementForm = ({ customButtons }) => {
  const { dayOptions, timeOptions } = useContactPreferenceOptions();

  const phoneUKKeypress = (event) => {
    const regex = /^[0-9 #+*]$/;
    if (!regex.test(event.key)) {
      event.preventDefault();
    }
  };

  return (
    <MainView BPadding1>
      <div className='px-6 py-8 smd:p-12'>
        <Heading classes='mb-2' h1>It looks like you've already joined us</Heading>
        <Text classes='mb-8' body>Complete the form below and we will call you to restart your journey.</Text>

        <div className='flex flex-col space-y-8'>
          <Field
            input='text'
            name='first_name'
            label='First Name'
            placeholder='First Name'
            isRequired
          />

          <Field
            input='text'
            name='last_name'
            label='Last Name'
            placeholder='Last Name'
            isRequired
          />

          <Field
            input='tel'
            name='phone_number'
            label='Preferred contact number'
            placeholder='Enter your preferred contact number'
            modalsubtitle='Why do we ask this?'
            modaltitle='Preferred contact number'
            help= 'We need your phone number so that our advisors can contact you to talk through your options.'
            isRequired
            validation={[phoneUK]}
            onKeyPress={phoneUKKeypress}
            maxLength={12}
          />

          <Field
            name='days'
            input='checkboxgroup'
            label='What days of the week are you likely to be available?'
            options={dayOptions}
            isRequired
          />

          <Field
            name='times'
            input='checkboxgroup'
            label='What times of day are you likely to be available?'
            options={timeOptions}
            isRequired
          />
        </div>

        { customButtons }
      </div>

    </MainView>
  );
};

ReEngagementForm.propTypes = {
  customButtons: PropTypes.element,
};
